import { DEFAULT_EMPTY_VALUE } from '../constants';
import {
  siteRequiresPassKey,
  siteRequiresPhotoIdKey,
  siteRequiresPhotoKey,
  VISITOR_PASS_TYPE,
  VISITOR_PHOTO_TYPE,
} from '../constants/visitor';
import {
  convertIdToValue,
  getItemOrDefaultToValue,
  getValueFromConstantObject,
} from '../details';
import { transformEmbeddedSiteForm } from '../SiteFormFields';

export const getSitePolicyPhotoIdType = list => {
  return convertIdToValue({
    list,
    key: siteRequiresPhotoIdKey,
    constant: VISITOR_PHOTO_TYPE,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

export const getSitePolicyPhotoType = list => {
  return convertIdToValue({
    list,
    key: siteRequiresPhotoKey,
    constant: VISITOR_PHOTO_TYPE,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

export const getSitePolicyPassType = list => {
  return convertIdToValue({
    list,
    key: siteRequiresPassKey,
    constant: VISITOR_PASS_TYPE,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

export const getSitePolicyPhotoIdTypeId = list => {
  const value = getItemOrDefaultToValue(list, siteRequiresPhotoIdKey);

  return value
    ? getValueFromConstantObject({
        constant: VISITOR_PHOTO_TYPE,
        value,
        key: 'id',
      })
    : '-';
};

export const getSitePolicyPhotoTypeId = list => {
  const value = getItemOrDefaultToValue(list, siteRequiresPhotoKey);

  return value
    ? getValueFromConstantObject({
        constant: VISITOR_PHOTO_TYPE,
        value,
        key: 'id',
      })
    : '-';
};

export const getSitePolicyPassTypeId = list => {
  const value = getItemOrDefaultToValue(list, siteRequiresPassKey);

  return value
    ? getValueFromConstantObject({
        constant: VISITOR_PASS_TYPE,
        value,
        key: 'id',
      })
    : '-';
};

export const getNewSiteData = ({
  values,
  regionId,
  regionName,
  companyId,
  companyName,
  businessClients,
  rawClients,
}) => {
  const securityObj = {
    regionId,
    regionName,
    securityCompanyId: companyId,
    securityCompanyName: companyName,
  };

  return transformEmbeddedSiteForm({
    values,
    userDetails: { ...securityObj },
    businessClients,
    rawClients,
  });
};

export const setSiteName = site => {
  const bizClientInfo = site?.businessClient;

  if (!site) {
    return DEFAULT_EMPTY_VALUE;
  } else {
    let sIdPrefix = '';
    let bClientIdPrefix = '';

    if (site.siteId !== DEFAULT_EMPTY_VALUE) {
      sIdPrefix = site.siteId ? `(${site.siteId})` : '';
    }

    if (bizClientInfo?.businessClientId !== DEFAULT_EMPTY_VALUE) {
      bClientIdPrefix = bizClientInfo?.businessClientId
        ? `(${bizClientInfo?.businessClientId})`
        : '';
    }
    const bizCLientName = bizClientInfo?.name ? bizClientInfo.name : '';
    const siteName = site.name ? site.name : '';
    const showColon =
      (bizCLientName === '' && bClientIdPrefix === '') ||
      (siteName === '' && sIdPrefix === '')
        ? ''
        : ':';
    // exact format for site display name is
    // Site Name (Site Id): BC Name (BC ID)
    // if the id is missing (as they are optional) it should be
    // Site Name: BC Name
    return ` ${siteName} ${sIdPrefix}${showColon} ${bizCLientName} ${bClientIdPrefix} `;
  }
};
